import { Component, inject } from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { ToastInfo } from '../../models/toast-info';
import { LoggingService } from '../../../services/logging.service';

@Component({
	selector: 'adf-toast',
	standalone: true,
	imports: [CommonModule, NgbToastModule],
	templateUrl: './toast.component.html',
	styleUrl: './toast.component.scss',
})
export class ToastComponent {
	private _loggingService = inject(LoggingService);

	toasts$ = this._loggingService.getToasts();

	removeToast(toast: ToastInfo) {
		this._loggingService.remove(toast);
	}
}
